import {
  MaterialUsageStateTypes,
  MaterialUsageActionTypes,
} from "./MaterialUsage.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialUsageStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MaterialUsageReducer = (
  state: MaterialUsageStateTypes = INITIAL_STATE,
  action: any
): MaterialUsageStateTypes => {
  switch (action.type) {
    case MaterialUsageActionTypes.FETCH_ALL_MATERIAL_USAGE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialUsageActionTypes.FETCH_ALL_MATERIAL_USAGE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialUsageActionTypes.FETCH_ALL_MATERIAL_USAGE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialUsageActionTypes.FETCH_ALL_MATERIAL_USAGE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MaterialUsageActionTypes.FETCH_ONE_MATERIAL_USAGE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialUsageActionTypes.FETCH_ONE_MATERIAL_USAGE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialUsageActionTypes.FETCH_ONE_MATERIAL_USAGE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialUsageActionTypes.FETCH_ONE_MATERIAL_USAGE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialUsageReducer;
